// extracted by mini-css-extract-plugin
export default {"buttons-group":"EditRecipeSizeModal-module__buttons-group__fEHor","button":"EditRecipeSizeModal-module__button__cMtUo"};